// import { DatePicker } from 'antd';
// import getChartColorsArray from 'components/Common/ChartsDynamicColor';
// import moment from 'moment';
// import Loader from 'pages/Separate/Loader';
// import React, { useEffect, useMemo, useState } from 'react'
// import ReactApexChart from 'react-apexcharts'
// import secureLocalStorage from 'react-secure-storage';
// import { Card, CardBody, Table } from 'reactstrap'
// import { fetchData, fetchNodeData, FetchNodePostData, FetchPostData } from 'utils/common-fetchData';
// import Select from "react-select"
// import { Link } from 'react-router-dom';
// import configure from 'configure';

// const { RangePicker } = DatePicker;

// const LeadIndReport = () => {
//     const dataColors = '[ "--bs-primary","--bs-success" ,"--bs-secondary" , "#bf1e30" , "rgb(253, 171, 153)"]';
//     const spineareaChartColors = getChartColorsArray(dataColors);
//     const [isTable, setIsTable] = useState(true)
//     const [isProposalTable, setIsProposalTable] = useState(true)
//     const [loading, setLoading] = useState(false)
//     const [tableData, setTableData] = useState([])
//     const [proposalData, setProposalData] = useState([])
//     const [data, setData] = useState([])
//     const [allData, setAllData] = useState([])
//     const [staffoption, setStaffOption] = useState([])
//     const [members, setMembers] = useState([])
//     const [tender, setTenderOption] = useState([])
//     const [dateRange, setDateRange] = useState([
//         moment().subtract(6, 'days'),
//         moment()
//     ]);
//     const series = useMemo(() => data, [data])
//     function generateLeadStatsByYear(year, leads) {
//         const initArray = () => Array(12).fill(0);

//         const result = {
//             "Total Leads": initArray(),
//             "Proposal Sent": initArray(),
//             "Lead Lost": initArray(),
//             "Hot Leads": initArray(),
//             "Warm Leads": initArray()
//         };

//         leads.forEach(lead => {
//             const createdDate = new Date(lead.created_at);
//             const month = createdDate.getMonth(); // 0 = Jan
//             const leadYear = createdDate.getFullYear();

//             if (leadYear == year) {
//                 result["Total Leads"][month] += 1;

//                 const leadStatus = (lead.status || "")?.toLowerCase();
//                 if (leadStatus == "proposal") {
//                     result["Proposal Sent"][month] += 1;
//                 }

//                 if (leadStatus == "lost") {
//                     result["Lead Lost"][month] += 1;
//                 }

//                 const leadType = (lead.lead_type || "")?.toLowerCase();
//                 if (leadType == "hot") {
//                     result["Hot Leads"][month] += 1;
//                 }

//                 if (leadType == "warm") {
//                     result["Warm Leads"][month] += 1;
//                 }
//             }
//         });

//         return Object.entries(result).map(([name, data]) => ({
//             name,
//             data
//         }));
//     }

//     function generateSummaryByDateRange(leads, startDate, endDate, memberString = "0") {
//         const start = new Date(startDate);
//         const end = new Date(endDate);
//         end.setHours(23, 59, 59, 999);
//         const formatDate = (date) =>
//             date.toLocaleDateString("en-GB", {
//                 day: "2-digit",
//                 month: "short",
//                 year: "numeric"
//             });

//         const filteredLeads = leads.filter((lead) => {
//             const created = new Date(lead.created_at);
//             const isInDateRange = created >= start && created <= end;

//             if (memberString.trim() == "0") {
//                 return isInDateRange;
//             }

//             const addedBy = Number(lead.added_by);
//             const members = memberString.split(',').map(m => Number(m.trim()));
//             const isMemberMatch = members.includes(addedBy);

//             return isInDateRange && isMemberMatch;
//         });

//         const summary = {
//             date: `${formatDate(start)} - ${formatDate(end)}`,
//             bark: 0,
//             em: 0,
//             proposal: 0,
//             introduction: 0,
//             new: 0,
//             meeting: 0,
//             lost: 0,
//             hot: 0,
//             onhold: 0,
//             website: 0,
//             seo: 0,
//             logo: 0,
//             app: 0,
//             maintainance: 0,
//             smatketing: 0,
//             portal: 0,
//             total: filteredLeads.length
//         };

//         filteredLeads.forEach((lead) => {
//             if ((lead.source || "")?.toLowerCase() == "bark") summary.bark++;
//             if ((lead.source || "") == "Email Marketing") summary.em++;
//             if ((lead.status || "")?.toLowerCase() == "proposal") summary.proposal++;
//             if ((lead.status || "")?.toLowerCase() == "introduction") summary.introduction++;
//             if ((lead.status || "")?.toLowerCase() == "new") summary.new++;
//             if ((lead.status || "")?.toLowerCase() == "meeting") summary.meeting++;
//             if ((lead.status || "")?.toLowerCase() == "lost") summary.lost++;
//             if ((lead.status || "")?.toLowerCase() == "onhold") summary.onhold++;
//             if ((lead.lead_type || "")?.toLowerCase() == "hot") summary.hot++;
//             if ((lead.service || "") == "Website Designing and Development" ||
//                 (lead.service || "") == "Website Redesigning") summary.website++;
//             if ((lead.service || "") == "E-Commerce Website Design and Development" || (lead.service || "") == "Customise CRM Development" || (lead.service || "") == "Custom Development of Website and CRM" || (lead.service || "") == "Custom Development of Website and CRM and Mobile Application" || (lead.service || "") == "Customise ERP Development") summary.portal++;
//             if ((lead.service || "") == "SEO") summary.seo++;
//             if ((lead.service || "") == "Graphics Designing") summary.logo++;
//             if ((lead.service || "") == "Mobile Application Development") summary.app++;
//             if ((lead.service || "") == "Maintenance Contract - Website" || (lead.service || "") == "Maintenance Contact - Custom System" || (lead.service || "") == "Maintenance Contract - Mobile Apps") summary.maintainance++;
//             if ((lead.service || "") == "Digital Marketing") summary.smatketing++;
//         });

//         return summary;
//     }

//     const options = {
//         chart: {
//             type: "area", // still an area chart, but without visible fill
//         },
//         dataLabels: {
//             enabled: false,
//         },
//         stroke: {
//             curve: "smooth",
//             width: 3,
//         },
//         fill: {
//             type: "solid",
//             opacity: 0,
//         },
//         colors: spineareaChartColors,
//         xaxis: {
//             type: "",
//             categories: [
//                 "Jan",
//                 "Feb",
//                 "Mar",
//                 "Apr",
//                 "May",
//                 "Jun",
//                 "Jul",
//                 "Aug",
//                 "Sep",
//                 "Oct",
//                 "Nov",
//                 "Dec",
//             ],
//             labels: {
//                 show: true,
//             },
//             yaxis: {
//                 labels: {
//                     show: true,
//                 },
//             },
//         },
//         grid: {
//             borderColor: "#f1f1f1",
//         },
//         tooltip: {
//             x: {
//                 format: "dd/MM/yy HH:mm",
//             },
//         },
//     };
//     const toggleLoading = (loading) => {
//         setLoading(loading);
//     }
//     const token = secureLocalStorage.getItem('auth_token')
//     const fetchODs = async () => {
//         const formEntires = {
//             user_id: 1,
//             location: 2,
//         }
//         const res = await FetchPostData(toggleLoading, 'lead', token, formEntires);
//         if (res?.data?.success) {
//             setAllData(res?.data?.data)
//             setData(generateLeadStatsByYear(new Date().getFullYear(), res?.data?.data))
//             setTableData([generateSummaryByDateRange(res?.data?.data, dateRange[0], dateRange[1], '0')])

//         }
//         const formData = {
//             startdate: moment(dateRange[0]).format('YYYY-MM-DD'),
//             enddate: moment(dateRange[1]).format('YYYY-MM-DD'),
//             location: 2
//         }
//         const res2 = await FetchNodePostData(toggleLoading, 'leadAnalysisDetails', token, formData);
//         if (res?.data?.success) {
//             setProposalData(res2?.data?.data)
//             setTenderOption(res2?.data?.tenders)
//         }
//         const response = await fetchData(toggleLoading, 'salesStaff', token);
//         if (response?.success) {
//             setStaffOption(response?.data?.map((obj) => ({
//                 label: obj?.alias_name,
//                 value: obj?.id
//             }
//             )))
//         }
//     }
//     useEffect(() => {
//         fetchODs()
//     }, [])

//     console.log(allData)
//     return (
//         <div>
//             {loading && (<Loader />)}
//             <Card>
//                 <CardBody>
//                     <div className='mb-4'>
//                         <div className='d-flex align-items-center justify-content-between mb-3'>
//                             <div className="col-6 mb-3 text-purple fs-5  fw-bold">Sales Performance Report For UK</div>
//                             <div className='d-flex gap-3 align-items-center'>
//                                 <div className="form-switch form-switch-md ps-5">
//                                     <input type="checkbox" className="form-check-input" id="customSwitchsizemd"
//                                         defaultChecked={true}
//                                         onChange={(e) => setIsTable(e.target.checked)} />
//                                 </div>
//                                 <select className="border-radius form-select" style={{
//                                     fontSize: "13px",
//                                     padding: "6px 23px 6px 12px",
//                                 }}
//                                     onChange={(e) => {
//                                         setData(generateLeadStatsByYear(e.target.value, allData))
//                                     }} >
//                                     <option value="2025">Current Year</option>
//                                     <option value="2024">Previous Year</option>
//                                 </select>
//                             </div>
//                         </div>
//                         <ReactApexChart
//                             options={options}
//                             series={series}
//                             type="area"
//                             height="300"
//                         />
//                     </div>
//                     {isTable ? (
//                         <div className="responsive-table pt-4 border-top">
//                             <div className="d-flex align-items-center justify-content-between mb-4">
//                                 <div className='d-flex gap-2 align-items-center'>
//                                     <div className="text-purple fs-5  fw-bold">
//                                         Detail Sales Summary
//                                     </div>
//                                     <a className="d-flex gap-3 align-items-center general-box ">
//                                         <h5 className="text-purple mb-0">Hot : </h5>
//                                         <h5 className="text-primary mb-0">{allData?.filter((obj) => obj?.lead_type == 'Hot' && obj?.status != "Lost" && obj?.status != "Convert to Client" && obj?.status != "Convert to Project" && obj?.status != "Convert to Introducer" && obj?.status != "Convert to Customer")?.length}</h5>
//                                     </a>
//                                     <a className="d-flex gap-3 align-items-center general-box ">
//                                         <h5 className="text-purple mb-0">Extreme Hot : </h5>
//                                         <h5 className="text-primary mb-0">{allData?.filter((obj) => obj?.lead_type == 'Extreme Hot')?.length}</h5>
//                                     </a>
//                                     <div className="form-switch form-switch-md ps-5">
//                                         <input type="checkbox" className="form-check-input" id="customSwitchsizemd"
//                                             defaultChecked={true}
//                                             onChange={(e) => setIsProposalTable(e.target.checked)} />
//                                     </div>
//                                 </div>
//                                 <div className='d-flex align-items-center gap-3 col-md-6 justify-content-end'>
//                                     <Select
//                                         placeholder="Select Member"
//                                         className="basic-multi-select col-md-6"
//                                         classNamePrefix="select"
//                                         isMulti
//                                         options={staffoption}
//                                         value={members}
//                                         onChange={(e) => setMembers(e)}
//                                     />
//                                     <RangePicker
//                                         className='col-md-4'
//                                         value={dateRange}
//                                         format="DD-MM-YYYY"
//                                         onChange={(dates) => {
//                                             if (dates != null) {
//                                                 setDateRange([moment(dates[0]?.$d), moment(dates[1]?.$d)])
//                                             }
//                                         }}
//                                         style={{ height: "38px" }}
//                                     />
//                                     <button className="btn btn-sm  bg-purple text-white"
//                                         onClick={async () => {
//                                             setLoading(true); // start loader
//                                             const formData = {
//                                                 startdate: moment(dateRange[0]).format('YYYY-MM-DD'),
//                                                 enddate: moment(dateRange[1]).format('YYYY-MM-DD'),
//                                                 location: 2
//                                             }
//                                             const res2 = await FetchNodePostData(toggleLoading, 'leadAnalysisDetails', token, formData);
//                                             if (res2?.data?.success) {
//                                                 setProposalData(res2?.data?.data)
//                                                 setTenderOption(res2?.data?.tenders)
//                                             }

//                                             setTimeout(() => {
//                                                 const allMembers = members?.length !== 0
//                                                     ? members.map((obj) => obj?.value).join(',')
//                                                     : '0';

//                                                 const summary = generateSummaryByDateRange(allData, dateRange[0], dateRange[1], allMembers);
//                                                 setTableData([summary]);

//                                                 setLoading(false); // stop loader
//                                             }, 400); // 2 seconds delay
//                                         }}
//                                     >
//                                         <i className="bi bi-funnel-fill fs-5"></i>
//                                     </button>
//                                 </div>

//                             </div>
//                             <Table className="table table-bordered mb-0">
//                                 <thead>
//                                     <tr>
//                                         <th className="header col">Date</th>
//                                         <th className="header bg-lights-purple text-white">Total</th>
//                                         <th className="header bg-lights-purple text-white">EM</th>
//                                         <th className="header bg-lights-purple text-white">BARK</th>
//                                         <th className="header bg-lights-purple text-white">Proposal</th>
//                                         <th className="header">Introduction</th>
//                                         <th className="header">New</th>
//                                         <th className="header">Meeting</th>
//                                         <th className="header bg-red">Lost</th>
//                                         <th className="header">Hot</th>
//                                         <th className="header">OnHold</th>
//                                         <th className="header bg-light-purple">Website</th>
//                                         <th className="header bg-light-purple">Portal</th>
//                                         <th className="header bg-light-purple">App</th>
//                                         <th className="header bg-light-purple">Maintainace</th>
//                                         <th className="header bg-light-purple">SEO</th>
//                                         <th className="header bg-light-purple">SMM</th>
//                                         <th className="header bg-light-purple ">Graphic</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {tableData?.map((obj, i) => {
//                                         return (
//                                             <tr key={i}>
//                                                 <td>
//                                                     {obj?.date}
//                                                 </td>
//                                                 <td className="text-center bg-lights-purple text-white">
//                                                     {obj?.total}
//                                                 </td>
//                                                 <td className="text-center bg-lights-purple text-white">
//                                                     {obj?.em}
//                                                 </td>
//                                                 <td className="text-center bg-lights-purple text-white">
//                                                     {obj?.bark}
//                                                 </td>
//                                                 <td className="text-center bg-lights-purple text-white">
//                                                     {obj?.proposal}
//                                                 </td>
//                                                 <td className="text-center">
//                                                     {obj?.introduction}
//                                                 </td>
//                                                 <td className="text-center">
//                                                     {obj?.new}
//                                                 </td>
//                                                 <td className="text-center">
//                                                     {obj?.meeting}
//                                                 </td>
//                                                 <td className="text-center bg-red">
//                                                     {obj?.lost}
//                                                 </td>
//                                                 <td className="text-center">
//                                                     {obj?.hot}
//                                                 </td>

//                                                 <td className="text-center">
//                                                     {obj?.onhold}
//                                                 </td>
//                                                 <td className="text-center bg-light-purple">
//                                                     {obj?.website}
//                                                 </td>
//                                                 <td className="text-center bg-light-purple">
//                                                     {obj?.portal}
//                                                 </td>
//                                                 <td className="text-center bg-light-purple">
//                                                     {obj?.app}
//                                                 </td>
//                                                 <td className="text-center bg-light-purple">
//                                                     {obj?.maintainance}
//                                                 </td>
//                                                 <td className="text-center bg-light-purple">
//                                                     {obj?.seo}
//                                                 </td>
//                                                 <td className="text-center bg-light-purple">
//                                                     {obj?.smatketing}
//                                                 </td>
//                                                 <td className="text-center bg-light-purple">
//                                                     {obj?.logo}
//                                                 </td>
//                                             </tr>
//                                         )
//                                     })}
//                                 </tbody>
//                             </Table>
//                         </div>
//                     ) : null}

//                     {isProposalTable ? (
//                         <div className="responsive-table pt-4 border-top mt-4">
//                             <div className="d-flex align-items-center justify-content-between mb-3">
//                                 <div className="col-4 mb-2 text-purple fs-5  fw-bold">Lead Proposal Summary</div>
//                                 <div
//                                     className="text-purple absent-length"
//                                     style={{ width: "30px", height: "30px" }}
//                                 >
//                                     {proposalData?.filter((obj) => obj?.proposal != null)?.length}/{proposalData?.length}
//                                 </div>
//                             </div>
//                             <Table className="table table-bordered mb-0">
//                                 <thead>
//                                     <tr>
//                                         <th className="header">Sr No.</th>
//                                         <th className="header">Company</th>
//                                         <th className="header">client Name</th>
//                                         <th className="header">Proposal Title</th>
//                                         <th className="header">Type</th>
//                                         <th className="header">Amount</th>
//                                         <th className="header">Created At</th>
//                                         <th className="header">Action</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {proposalData?.map((obj, i) => {
//                                         const array = typeof obj?.proposal?.costbreakdown === 'string'
//                                             ? JSON.parse(obj.proposal.costbreakdown)
//                                             : [];
//                                         const totalSum = array?.reduce((accumulator, item) => {
//                                             const totalValue = parseFloat(item.totalcost) // Convert "total" to a number
//                                             if (!isNaN(totalValue)) {
//                                                 return accumulator + totalValue
//                                             }
//                                             return accumulator
//                                         }, 0)

//                                         const personal = JSON.parse(obj.person_details)
//                                         let PersonName
//                                         if (personal != null && personal?.length == 0) {
//                                             PersonName = "-"
//                                         } else if (personal != null) {
//                                             PersonName = personal[0]?.person_name
//                                         }
//                                         return (
//                                             <tr key={i} className={`${obj?.proposal == null ? 'bg-light-red' : ''}`}>
//                                                 <td>
//                                                     {obj?.id}
//                                                 </td>
//                                                 <td className="">
//                                                     {obj?.company}
//                                                 </td>
//                                                 <td className="">
//                                                     {PersonName}
//                                                 </td>
//                                                 <td className="">
//                                                     {obj?.proposal?.id} - {obj?.proposal?.proposaltitile || ''}
//                                                 </td>
//                                                 <td className="">
//                                                     {obj?.proposal?.type || '-'}
//                                                 </td>
//                                                 <td className="">
//                                                     {obj?.proposal?.currency_symbol || ''} {totalSum || '-'}
//                                                 </td>
//                                                 <td className="">
//                                                     {obj?.proposal != null ? moment(obj?.proposal?.created_at).format('DD-MM-YYYY') : '-'}
//                                                 </td>
//                                                 <td className=''>
//                                                     <Link to={`${configure.appUrl}sales/edit-lead/${obj?.id}`} className="btn btn-sm btn-outline-secondary me-1" target='_blank' title='Lead Details'>
//                                                         <i className="fas fa-pencil-alt"></i>
//                                                     </Link>
//                                                     <Link to={`${configure.appUrl}sales/edit-proposal/${obj?.proposal?.id}`} className="btn btn-sm btn-outline-secondary me-1" target='_blank' title='Proposal Details'>
//                                                         <i className="fas fa-file-alt "></i>
//                                                     </Link>
//                                                 </td>
//                                             </tr>
//                                         )
//                                     })}
//                                 </tbody>
//                             </Table>
//                         </div>
//                     ) : null}

//                     <div className="responsive-table pt-4 border-top mt-4">
//                         <div className="d-flex align-items-center justify-content-between mb-3">
//                             <div className="col-4 mb-2 text-purple fs-5  fw-bold">Tender Summary</div>
//                         </div>
//                         <Table className="table table-bordered mb-0">
//                             <thead>
//                                 <tr>
//                                     <th className="header">Sr No.</th>
//                                     <th className="header">Tender Name</th>
//                                     <th className="header">Company</th>
//                                     <th className="header">Apply Date</th>
//                                     <th className="header">Tender Submission Date</th>
//                                     <th className="header">Budget</th>
//                                     <th className="header">Status</th>
//                                     <th className="header">Action</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {tender?.map((obj, i) => {
//                                     return (
//                                         <tr key={i} >
//                                             <td>
//                                                 {obj?.id}
//                                             </td>
//                                             <td className="">
//                                                 {obj?.name}
//                                             </td>
//                                             <td className="">
//                                                 {obj?.company_name || obj?.contact_name}
//                                             </td>
//                                             <td className="">
//                                                 {moment(obj?.apply_date).format('DD-MM-YYYY')}
//                                             </td>
//                                             <td className="">
//                                                 {moment(obj?.tender_submittion_date).format('DD-MM-YYYY')}
//                                             </td>
//                                             <td className="">
//                                                 {obj?.currency_symbol} {obj?.budget}
//                                             </td>
//                                             <td className="text-capitalize">
//                                                 {obj?.status}
//                                             </td>
//                                             <td className=''>
//                                                 <Link to={`${configure.appUrl}marketing/edit-tender/${obj?.id}`} className="btn btn-sm btn-outline-secondary me-1" target='_blank' title='Proposal Details'>
//                                                     <i className="fas fa-file-alt "></i>
//                                                 </Link>
//                                             </td>
//                                         </tr>
//                                     )
//                                 })}
//                             </tbody>
//                         </Table>
//                     </div>

//                 </CardBody>
//             </Card>

//         </div>
//     )
// }

// export default LeadIndReport

import { DatePicker } from "antd";
import getChartColorsArray from "components/Common/ChartsDynamicColor";
import moment from "moment";
import Loader from "pages/Separate/Loader";
import React, { useEffect, useMemo, useState } from "react";
import ReactApexChart from "react-apexcharts";
import secureLocalStorage from "react-secure-storage";
import { Card, CardBody, Table } from "reactstrap";
import {
  fetchData,
  fetchNodeData,
  FetchNodePostData,
  FetchPostData,
} from "utils/common-fetchData";
import Select from "react-select";
import { Link } from "react-router-dom";
import configure from "configure";
import { colourStyles } from "utils/common-options";

const { RangePicker } = DatePicker;

const LeadIndReport = () => {
  const dataColors =
    '["--bs-primary","--bs-success","--bs-secondary","#bf1e30","rgb(253, 171, 153)"]';
  const spineareaChartColors = getChartColorsArray(dataColors);
  const [isTable, setIsTable] = useState(true);
  const [isProposalTable, setIsProposalTable] = useState(true);
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [proposalData, setProposalData] = useState([]);
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [staffoption, setStaffOption] = useState([]);
  const [members, setMembers] = useState([]);
  const [tender, setTenderOption] = useState([]);
  const [dateRange, setDateRange] = useState([
    moment().subtract(6, "days"),
    moment(),
  ]);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState("all");

  const monthLabels = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const monthLabelsFull = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const currentYear = new Date().getFullYear();
  const previousYear = currentYear - 1;
  const currentMonth = new Date().getMonth(); // 0 = Jan, 1 = Feb, ..., 9 = Oct

  const series = useMemo(() => data, [data]);

  function generateLeadStatsByYear(year, leads) {
    const isCurrentYear = year === currentYear;
    const maxMonth = isCurrentYear ? currentMonth : 11; // Limit to current month for current year

    if (selectedMonth === "all") {
      // Monthly aggregation for all months up to maxMonth
      const initArray = () => Array(maxMonth + 1).fill(0);

      const result = {
        "Total Leads": initArray(),
        "Proposal Sent": initArray(),
        "Lead Lost": initArray(),
        "Hot Leads": initArray(),
        "Warm Leads": initArray(),
      };

      leads.forEach((lead) => {
        const createdDate = new Date(lead.created_at);
        const month = createdDate.getMonth(); // 0 = Jan
        const leadYear = createdDate.getFullYear();

        if (leadYear === year && month <= maxMonth) {
          result["Total Leads"][month] += 1;

          const leadStatus = (lead?.status || "")?.toLowerCase();
          if (leadStatus === "proposal") {
            result["Proposal Sent"][month] += 1;
          }

          if (leadStatus === "lost") {
            result["Lead Lost"][month] += 1;
          }

          const leadType = (lead?.lead_type || "")?.toLowerCase();
          if (leadType === "hot") {
            result["Hot Leads"][month] += 1;
          }

          if (leadType === "warm") {
            result["Warm Leads"][month] += 1;
          }
        }
      });

      return Object.entries(result).map(([name, data]) => ({
        name,
        data,
      }));
    } else {
      // Weekly aggregation for selected month
      const monthIndex = parseInt(selectedMonth);
      if (isCurrentYear && monthIndex > currentMonth) {
        // Return empty data if selected month is in the future
        return [
          { name: "Total Leads", data: [0, 0, 0, 0] },
          { name: "Proposal Sent", data: [0, 0, 0, 0] },
          { name: "Lead Lost", data: [0, 0, 0, 0] },
          { name: "Hot Leads", data: [0, 0, 0, 0] },
          { name: "Warm Leads", data: [0, 0, 0, 0] },
        ];
      }

      const initArray = () => Array(4).fill(0); // 4 weeks
      const result = {
        "Total Leads": initArray(),
        "Proposal Sent": initArray(),
        "Lead Lost": initArray(),
        "Hot Leads": initArray(),
        "Warm Leads": initArray(),
      };

      const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();
      const daysPerWeek = Math.ceil(daysInMonth / 4); // Approximate weeks

      leads.forEach((lead) => {
        const createdDate = new Date(lead.created_at);
        const leadYear = createdDate.getFullYear();
        const leadMonth = createdDate.getMonth();
        const day = createdDate.getDate();

        if (leadYear === year && leadMonth === monthIndex) {
          const weekIndex = Math.min(Math.floor((day - 1) / daysPerWeek), 3); // 0 to 3
          result["Total Leads"][weekIndex] += 1;

          const leadStatus = (lead?.status || "")?.toLowerCase();
          if (leadStatus === "proposal") {
            result["Proposal Sent"][weekIndex] += 1;
          }

          if (leadStatus === "lost") {
            result["Lead Lost"][weekIndex] += 1;
          }

          const leadType = (lead?.lead_type || "")?.toLowerCase();
          if (leadType === "hot") {
            result["Hot Leads"][weekIndex] += 1;
          }

          if (leadType === "warm") {
            result["Warm Leads"][weekIndex] += 1;
          }
        }
      });

      return Object.entries(result).map(([name, data]) => ({
        name,
        data,
      }));
    }
  }

  function generateSummaryByDateRange(
    leads,
    startDate,
    endDate,
    memberString = "0"
  ) {
    const start = new Date(startDate);
    const end = new Date(endDate);
    end.setHours(23, 59, 59, 999);
    const formatDate = (date) =>
      date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });

    const filteredLeads = leads.filter((lead) => {
      const created = new Date(lead.created_at);
      const isInDateRange = created >= start && created <= end;

      if (memberString.trim() === "0") {
        return isInDateRange;
      }

      const addedBy = Number(lead.added_by);
      const members = memberString.split(",").map((m) => Number(m.trim()));
      const isMemberMatch = members.includes(addedBy);

      return isInDateRange && isMemberMatch;
    });

    const summary = {
      date: `${formatDate(start)} - ${formatDate(end)}`,
      bark: 0,
      em: 0,
      proposal: 0,
      introduction: 0,
      new: 0,
      meeting: 0,
      lost: 0,
      hot: 0,
      onhold: 0,
      website: 0,
      seo: 0,
      logo: 0,
      app: 0,
      maintainance: 0,
      smatketing: 0,
      portal: 0,
      total: filteredLeads.length,
    };

    filteredLeads.forEach((lead) => {
      if ((lead?.source || "")?.toLowerCase() === "bark") summary.bark++;
      if ((lead?.source || "") === "Email Marketing") summary.em++;
      if ((lead?.status || "")?.toLowerCase() === "proposal")
        summary.proposal++;
      if ((lead?.status || "")?.toLowerCase() === "introduction")
        summary.introduction++;
      if ((lead?.status || "")?.toLowerCase() === "new") summary.new++;
      if ((lead?.status || "")?.toLowerCase() === "meeting") summary.meeting++;
      if ((lead?.status || "")?.toLowerCase() === "lost") summary.lost++;
      if ((lead?.status || "")?.toLowerCase() === "onhold") summary.onhold++;
      if ((lead?.lead_type || "")?.toLowerCase() === "hot") summary.hot++;
      if (
        (lead?.service || "") === "Website Designing and Development" ||
        (lead?.service || "") === "Website Redesigning"
      )
        summary.website++;
      if (
        (lead?.service || "") === "E-Commerce Website Design and Development" ||
        (lead?.service || "") === "Customise CRM Development" ||
        (lead?.service || "") === "Custom Development of Website and CRM" ||
        (lead?.service || "") ===
          "Custom Development of Website and CRM and Mobile Application" ||
        (lead?.service || "") === "Customise ERP Development"
      )
        summary.portal++;
      if ((lead?.service || "") === "SEO") summary.seo++;
      if ((lead?.service || "") === "Graphics Designing") summary.logo++;
      if ((lead?.service || "") === "Mobile Application Development")
        summary.app++;
      if (
        (lead?.service || "") === "Maintenance Contract - Website" ||
        (lead?.service || "") === "Maintenance Contact - Custom System" ||
        (lead?.service || "") === "Maintenance Contract - Mobile Apps"
      )
        summary.maintainance++;
      if ((lead?.service || "") === "Digital Marketing") summary.smatketing++;
    });

    return summary;
  }

  const options = {
    chart: {
      type: "area",
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: 3,
    },
    fill: {
      type: "solid",
      opacity: 0.1,
    },
    colors: spineareaChartColors,
    xaxis: {
      type: "",
      categories: monthLabels.slice(0, currentMonth + 1), // Use abbreviations up to current month
      labels: {
        show: true,
      },
    },
    yaxis: {
      labels: {
        show: true,
      },
    },
    grid: {
      borderColor: "#f1f1f1",
    },
    tooltip: {
      x: {
        format: "dd/MM/yy HH:mm",
      },
    },
  };

  const toggleLoading = (loading) => {
    setLoading(loading);
  };

  const token = secureLocalStorage.getItem("auth_token");

  const fetchODs = async () => {
    const formEntries = {
      user_id: 1,
      location: 2,
    };
    const res = await FetchPostData(toggleLoading, "lead", token, formEntries);
    if (res?.data?.success) {
      setAllData(res?.data?.data);
      setTableData([
        generateSummaryByDateRange(
          res?.data?.data,
          dateRange[0],
          dateRange[1],
          "0"
        ),
      ]);
    }
    const formData = {
      startdate: moment(dateRange[0]).format("YYYY-MM-DD"),
      enddate: moment(dateRange[1]).format("YYYY-MM-DD"),
      location: 2,
    };
    const res2 = await FetchNodePostData(
      toggleLoading,
      "leadAnalysisDetails",
      token,
      formData
    );
    if (res2?.data?.success) {
      setProposalData(res2?.data?.data);
      setTenderOption(res2?.data?.tenders);
    }
    const response = await fetchData(toggleLoading, "salesStaff", token);
    if (response?.success) {
      setStaffOption(
        response?.data?.map((obj) => ({
          label: obj?.alias_name,
          value: obj?.id,
        }))
      );
    }
  };

  useEffect(() => {
    fetchODs();
  }, []);

  useEffect(() => {
    if (allData.length > 0) {
      let stats = generateLeadStatsByYear(selectedYear, allData);
      let updatedOptions = { ...options };

      if (selectedMonth !== "all") {
        const monthIndex = parseInt(selectedMonth);
        const daysInMonth = new Date(selectedYear, monthIndex + 1, 0).getDate();
        const daysPerWeek = Math.ceil(daysInMonth / 4);
        updatedOptions.xaxis.categories = [
          `1-${daysPerWeek}`,
          `${daysPerWeek + 1}-${Math.min(daysPerWeek * 2, daysInMonth)}`,
          `${Math.min(daysPerWeek * 2 + 1, daysInMonth + 1)}-${Math.min(
            daysPerWeek * 3,
            daysInMonth
          )}`,
          `${Math.min(daysPerWeek * 3 + 1, daysInMonth + 1)}-${daysInMonth}`,
        ];
      } else {
        updatedOptions.xaxis.categories =
          selectedYear === currentYear
            ? monthLabels.slice(0, currentMonth + 1) // Use abbreviations up to current month
            : monthLabels; // Use all abbreviations for previous years
      }

      setData(stats);
      setOptions(updatedOptions);
    }
  }, [selectedYear, selectedMonth, allData]);

  const [chartOptions, setOptions] = useState(options);

  return (
    <div>
      {loading && <Loader />}
      <Card>
        <CardBody>
          <div className="mb-4">
            <div className="d-flex align-items-center justify-content-between mb-3">
              <div className="col-6 mb-3 text-purple fs-5 fw-bold">
                Sales Performance Report For UK
              </div>
              <div className="d-flex gap-3 align-items-center">
                <div className="form-switch form-switch-md ps-5">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="customSwitchsizemd"
                    defaultChecked={true}
                    onChange={(e) => setIsTable(e.target.checked)}
                  />
                </div>
                <select
                  className="border-radius form-select"
                  style={{
                    fontSize: "13px",
                    padding: "6px 23px 6px 12px",
                    background: "white",
                    zIndex: 1200,
                  }}
                  onChange={(e) => setSelectedYear(Number(e.target.value))}
                  value={selectedYear}
                >
                  <option value={currentYear}>Current Year</option>
                  <option value={previousYear}>Previous Year</option>
                </select>
                <select
                  className="border-radius form-select"
                  style={{
                    fontSize: "13px",
                    padding: "6px 23px 6px 12px",
                  }}
                  onChange={(e) => setSelectedMonth(e.target.value)}
                  value={selectedMonth}
                >
                  <option value="all">All Months</option>
                  {monthLabelsFull
                    .slice(
                      0,
                      selectedYear === currentYear ? currentMonth + 1 : 12
                    )
                    .map((month, index) => (
                      <option key={index} value={index}>
                        {month}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            <ReactApexChart
              options={chartOptions}
              series={series}
              type="area"
              height="300"
            />
          </div>
          {isTable ? (
            <div className="responsive-table pt-4 border-top">
              <div className="d-flex align-items-center justify-content-between mb-4">
                <div className="d-flex gap-2 align-items-center">
                  <div className="text-purple fs-5 fw-bold">
                    Detail Sales Summary
                  </div>
                  <a className="d-flex gap-3 align-items-center general-box">
                    <h5 className="text-purple mb-0">Hot :</h5>
                    <h5 className="text-primary mb-0">
                      {
                        allData?.filter(
                          (obj) =>
                            (obj?.lead_type || "")?.toLowerCase() == "hot"
                        )?.length
                      }
                    </h5>
                  </a>
                  <a className="d-flex gap-3 align-items-center general-box">
                    <h5 className="text-purple mb-0">Extreme Hot :</h5>
                    <h5 className="text-primary mb-0">
                      {
                        allData?.filter(
                          (obj) =>
                            (obj?.lead_type || "")?.toLowerCase() ==
                            "extreme hot"
                        )?.length
                      }
                    </h5>
                  </a>
                  <div className="form-switch form-switch-md ps-5">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="customSwitchsizemd"
                      defaultChecked={true}
                      onChange={(e) => setIsProposalTable(e.target.checked)}
                    />
                  </div>
                </div>
                <div className="d-flex align-items-center gap-3 col-md-6 justify-content-end">
                  <Select
                    placeholder="Select Member"
                    className="basic-multi-select col-md-6"
                    classNamePrefix="select"
                    isMulti
                    options={staffoption}
                    value={members}
                    onChange={(e) => setMembers(e)}
                  />
                  <RangePicker
                    className="col-md-4"
                    value={dateRange}
                    format="DD-MM-YYYY"
                    onChange={(dates) => {
                      if (dates != null) {
                        setDateRange([
                          moment(dates[0]?.$d),
                          moment(dates[1]?.$d),
                        ]);
                      }
                    }}
                    style={{ height: "38px" }}
                  />
                  <button
                    className="btn btn-sm bg-purple text-white"
                    onClick={async () => {
                      setLoading(true);
                      const formData = {
                        startdate: moment(dateRange[0]).format("YYYY-MM-DD"),
                        enddate: moment(dateRange[1]).format("YYYY-MM-DD"),
                        location: 2,
                      };
                      const res2 = await FetchNodePostData(
                        toggleLoading,
                        "leadAnalysisDetails",
                        token,
                        formData
                      );
                      if (res2?.data?.success) {
                        setProposalData(res2?.data?.data);
                        setTenderOption(res2?.data?.tenders);
                      }

                      setTimeout(() => {
                        const allMembers =
                          members?.length !== 0
                            ? members.map((obj) => obj?.value).join(",")
                            : "0";
                        const summary = generateSummaryByDateRange(
                          allData,
                          dateRange[0],
                          dateRange[1],
                          allMembers
                        );
                        setTableData([summary]);
                        setLoading(false);
                      }, 400);
                    }}
                  >
                    <i className="bi bi-funnel-fill fs-5"></i>
                  </button>
                </div>
              </div>
              <Table className="table table-bordered mb-0">
                <thead>
                  <tr>
                    <th className="header col">Date</th>
                    <th className="header bg-lights-purple text-white">
                      Total
                    </th>
                    <th className="header bg-lights-purple text-white">EM</th>
                    <th className="header bg-lights-purple text-white">BARK</th>
                    <th className="header bg-lights-purple text-white">
                      Proposal
                    </th>
                    <th className="header">Introduction</th>
                    <th className="header">New</th>
                    <th className="header">Meeting</th>
                    <th className="header bg-red">Lost</th>
                    <th className="header">Hot</th>
                    <th className="header">OnHold</th>
                    <th className="header bg-light-purple">Website</th>
                    <th className="header bg-light-purple">Portal</th>
                    <th className="header bg-light-purple">App</th>
                    <th className="header bg-light-purple">Maintainace</th>
                    <th className="header bg-light-purple">SEO</th>
                    <th className="header bg-light-purple">SMM</th>
                    <th className="header bg-light-purple">Graphic</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData?.map((obj, i) => (
                    <tr key={i}>
                      <td>{obj?.date}</td>
                      <td className="text-center bg-lights-purple text-white">
                        {obj?.total}
                      </td>
                      <td className="text-center bg-lights-purple text-white">
                        {obj?.em}
                      </td>
                      <td className="text-center bg-lights-purple text-white">
                        {obj?.bark}
                      </td>
                      <td className="text-center bg-lights-purple text-white">
                        {obj?.proposal}
                      </td>
                      <td className="text-center">{obj?.introduction}</td>
                      <td className="text-center">{obj?.new}</td>
                      <td className="text-center">{obj?.meeting}</td>
                      <td className="text-center bg-red">{obj?.lost}</td>
                      <td className="text-center">{obj?.hot}</td>
                      <td className="text-center">{obj?.onhold}</td>
                      <td className="text-center bg-light-purple">
                        {obj?.website}
                      </td>
                      <td className="text-center bg-light-purple">
                        {obj?.portal}
                      </td>
                      <td className="text-center bg-light-purple">
                        {obj?.app}
                      </td>
                      <td className="text-center bg-light-purple">
                        {obj?.maintainance}
                      </td>
                      <td className="text-center bg-light-purple">
                        {obj?.seo}
                      </td>
                      <td className="text-center bg-light-purple">
                        {obj?.smatketing}
                      </td>
                      <td className="text-center bg-light-purple">
                        {obj?.logo}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          ) : null}

          {isProposalTable ? (
            <div className="responsive-table pt-4 border-top mt-4">
              <div className="d-flex align-items-center justify-content-between mb-3">
                <div className="col-4 mb-2 text-purple fs-5 fw-bold">
                  Lead Proposal Summary
                </div>
                <div
                  className="text-purple absent-length"
                  style={{ width: "30px", height: "30px" }}
                >
                  {proposalData?.filter((obj) => obj?.proposal == null)?.length}
                  /{proposalData?.length}
                </div>
              </div>
              <Table className="table table-bordered mb-0">
                <thead>
                  <tr>
                    <th className="header">Sr No.</th>
                    <th className="header">Company</th>
                    <th className="header">Client Name</th>
                    <th className="header">Proposal Title</th>
                    <th className="header">Type</th>
                    <th className="header">Amount</th>
                    <th className="header">Created At</th>
                    <th className="header">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {proposalData?.map((obj, i) => {
                    const array =
                      typeof obj?.proposal?.costbreakdown === "string"
                        ? JSON.parse(obj.proposal.costbreakdown)
                        : [];
                    const totalSum = array?.reduce((accumulator, item) => {
                      const totalValue = parseFloat(item.totalcost);
                      if (!isNaN(totalValue)) {
                        return accumulator + totalValue;
                      }
                      return accumulator;
                    }, 0);
                    return (
                      <tr
                        key={i}
                        className={`${
                          obj?.proposal == null ? "bg-light-red" : ""
                        }`}
                      >
                        <td>{obj?.id}</td>
                        <td>{obj?.company}</td>
                        <td>manav</td>
                        <td>
                          {obj?.proposal?.id} -{" "}
                          {obj?.proposal?.proposaltitile || ""}
                        </td>
                        <td>{obj?.proposal?.type || "-"}</td>
                        <td>
                          {obj?.proposal?.currency_symbol || ""} {totalSum || 0}
                        </td>
                        <td>
                          {moment(obj?.proposal?.created_at).format(
                            "DD-MM-YYYY"
                          ) || "-"}
                        </td>
                        <td>
                          <Link
                            to={`${configure.appUrl}sales/edit-lead/${obj?.id}`}
                            className="btn btn-sm btn-outline-secondary me-1"
                            target="_blank"
                            title="Lead Details"
                          >
                            <i className="fas fa-pencil-alt"></i>
                          </Link>
                          <Link
                            to={`${configure.appUrl}sales/edit-proposal/${obj?.proposal?.id}`}
                            className="btn btn-sm btn-outline-secondary me-1"
                            target="_blank"
                            title="Proposal Details"
                          >
                            <i className="fas fa-file-alt"></i>
                          </Link>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          ) : null}

          <div className="responsive-table pt-4 border-top mt-4">
            <div className="d-flex align-items-center justify-content-between mb-3">
              <div className="col-4 mb-2 text-purple fs-5 fw-bold">
                Tender Summary
              </div>
            </div>
            <Table className="table table-bordered mb-0">
              <thead>
                <tr>
                  <th className="header">Sr No.</th>
                  <th className="header">Tender Name</th>
                  <th className="header">Company</th>
                  <th className="header">Apply Date</th>
                  <th className="header">Tender Submission Date</th>
                  <th className="header">Budget</th>
                  <th className="header">Status</th>
                  <th className="header">Action</th>
                </tr>
              </thead>
              <tbody>
                {tender?.map((obj, i) => (
                  <tr key={i}>
                    <td>{obj?.id}</td>
                    <td>{obj?.name}</td>
                    <td>{obj?.company_name || obj?.contact_name}</td>
                    <td>{moment(obj?.apply_date).format("DD-MM-YYYY")}</td>
                    <td>
                      {moment(obj?.tender_submittion_date).format("DD-MM-YYYY")}
                    </td>
                    <td>
                      {obj?.currency_symbol} {obj?.budget}
                    </td>
                    <td className="text-capitalize">{obj?.status}</td>
                    <td>
                      <Link
                        to={`${configure.appUrl}marketing/edit-tender/${obj?.id}`}
                        className="btn btn-sm btn-outline-secondary me-1"
                        target="_blank"
                        title="Proposal Details"
                      >
                        <i className="fas fa-file-alt"></i>
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default LeadIndReport;
